module.exports = __webpack_public_path__ + "media/components/Cards/images/Gold-Elegant-Business-Card-5cab84d09d1d540c2e77d2f58a38b5e0.png";